import { createContext } from "react";
import { Therapist } from "../modules/therapist/domain/Therapist";

export interface TherapistContextType {
    therapist: Therapist | null;
    loadingTherapist: boolean;
    setTherapist: (t: Therapist | null) => void;
    refreshTherapist: () => Promise<void>;
}

export const TherapistContext = createContext<TherapistContextType>({
    therapist: null,
    loadingTherapist: true,
    setTherapist: () => { },
    refreshTherapist: async () => { },
});
